var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class ActorInteract {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get isActorHovering() {
        return this.allAspectMouseInteracts.map(i => i.isAspectHovering).includes(true);
    }
    get isActorActive() {
        return this.allAspectMouseInteracts.map(i => i.isAspectActive).includes(true);
    }
    get allAspectMouseInteracts() {
        return this.actor.actorMounted.renderedAspects.map(aspect => aspect.aspectInteract);
    }
}
__decorate([
    computed
], ActorInteract.prototype, "isActorHovering", null);
__decorate([
    computed
], ActorInteract.prototype, "isActorActive", null);
__decorate([
    computed
], ActorInteract.prototype, "allAspectMouseInteracts", null);
